"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var _classLib = require("class-lib");
var _reshowBuild = _interopRequireDefault(require("reshow-build"));
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _excluded = ["component", "pureUnitOne", "ui", "className"];
var Column = function Column(_ref) {
  var _ref$component = _ref.component,
    component = _ref$component === void 0 ? _SemanticUI["default"] : _ref$component,
    _ref$pureUnitOne = _ref.pureUnitOne,
    pureUnitOne = _ref$pureUnitOne === void 0 ? true : _ref$pureUnitOne,
    _ref$ui = _ref.ui,
    ui = _ref$ui === void 0 ? false : _ref$ui,
    className = _ref.className,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var classes = (0, _classLib.mixClass)(className, "column", {
    "pure-u-1": pureUnitOne
  });
  return (0, _reshowBuild["default"])(component)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    ui: ui,
    className: classes
  }));
};
var _default = exports["default"] = Column;
module.exports = exports.default;